module.exports = __webpack_public_path__ + "img/web3icon1.41749f19.png";